// Константы для пільг (в майбутньому будуть отримуватись з API)
export const ageCategory = [
    {v: "1_3", t: "Від 1 до 3-х років"},
    {v: "3_4", t: "Від 3-х до 4-х років"},
    {v: "4_8", t: "Від 4 до 8-ми років"},
    {v: "all", t: "Всі"},
];

export const ageCategoryKitchen = [
    {v: "all", t: "Всі"},
];

export const benefitCategory = [
    {v:"kg", t:"В садочку"},
    {v:"kitchen", t:"По харчуванню"}
];

export const shortnames = {
    "all": {
      "name": "Всі", 
      "short": "Всі"
    },
    "58a08c62f61e7e67affe07db": {
      "name": "Діти громадян, які постраждали внаслідок Чорнобильської катастрофи (1, 2, 3 категорій). Діти, яким встановлено інвалідність, пов'язану з Чорнобильською катастрофою",
      "short": "Чорнобильська"
    },
    "58a08d05f61e7e67affe07e4": {
      "name": "Діти військовослужбовців Національної гвардії України",
      "short": "Нацгвардія"
    },
    "58a08e04f61e7e67affe07e6": {
      "name": "Діти військовослужбовців",
      "short": "Військові"
    },
    "58a08e72f61e7e67affe07e8": {
      "name": "Діти киян - учасників АТО",
      "short": "АТО"
    },
    "58eb6171bbc6a007c939478a": {
      "name": "Діти з числа внутрішньо переміщених осіб чи діти, які мають статус дитини, яка постраждала внаслідок воєнних дій і збройних конфліктів",
      "short": "ВПО"
    },
    "5bfb996f0b7fb2059b8828c9": {
      "name": "Брати та сестри в одному ЗДО",
      "short": "Брати"
    },
    "5bfb99ad0b7fb2059b8828ca": {
      "name": "Діти з особливими освітніми потребами",
      "short": "Особливі"
    },
    "5c16b5a22f8be751f04fce92": {
      "name": "Діти працівників закладу",
      "short": "Працівники"
    },
    "5c73fbeba2abb113f438392d": {
      "name": "діти працівників дипломатичної служби",
      "short": "Дипломати"
    },
    "5e678e4b90cb7761dcbbc71a": {
      "name": "Діти киян Героїв Небесної Сотні та постраждалим учасникам Революції Гідності",
      "short": "Небесна Сотня"
    },
    "604a4455a819006871f1c7c1": {
      "name": "Діти-сироти, під опікою, усиновлені, прийомна або патронатна сім’я, дит. будинок сімейного типу",
      "short": "Діти-сироти"
    },
    "604a44b15d9b0450cd3317af": {
      "name": "У складних життєвих обставинах та на обліку в службах у справах дітей",
      "short": "Складні"
    },
    "60e81561904ae40729056dc4": {
      "name": "Територія обслуговування(один садок)",
      "short": "Територія"
    },
    "63be773bce1af40753ec6b2d": {
      "name": "діти учасників бойових дій на території інших держав, які стали особами з інвалідністю внаслідок поранення, контузії, каліцтва або захворювання",
      "short": "Учасники БД"
    },
    "63c7b39620879006ea0c507f": {
      "name": "діти киян, які приймали (приймають участь) у заходах, необхідних для забезпечення оборони України у зв’язку з військовою агресією російської федерації проти України, членам їх сімей, членам загиблих (померлих) Захисників і Захисниць України",
      "short": "Захісники"
    },
    "66fbd5984954c90779d9c9ae":{
      "name": "Діти, які мають статус дитини, яка постраждала внаслідок воєнних дій і збройних конфліктів",
      "short":"Постражділі від воєних дій"
    }
};

export const shortnames_kitch = {
    "all": {name: "Всі", short: "Всі"},
    "1": {
      "name": "Діти учасників АТО",
      "short": "Діти учасників АТО"
    },
    "6": {
      "name": "Діти з багатодітних сімей",
      "short": "Діти з багатодітних сімей"
    },
    "7": {
      "name": "Діти ВПО",
      "short": "Діти ВПО"
    },
    "8": {
      "name": "Малозабезпечені сім’ї",
      "short": "Малозабезпечені сім’ї"
    },
    "9": {
      "name": "Діти з інвалідністю",
      "short": "Діти з інвалідністю"
    },
    "10": {
      "name": "Опіка",
      "short": "Опіка"
    },
    "12": {
      "name": "Діти з особливими освітними потребами (100%)",
      "short": "Діти з особливими освітними потребами (100%)"
    },
    "13": {
      "name": "Діти загиблих(померлих) Захисників і Захисниць України (100%)",
      "short": "Діти загиблих(померлих) Захисників і Захисниць України (100%)"
    },
    "14": {
      "name": "Діти киян, які брали( беруть) участь у заходах, необхідних для забезпечення оборони України (100%)",
      "short": "Діти киян, які брали( беруть) участь у заходах, необхідних для забезпечення оборони України (100%)"
    },
    "15": {
      "name": "Діти киян, які брали( беруть) участь у заходах, необхідних для забезпечення оборони України (одна гривня)",
      "short": "Діти киян, які брали( беруть) участь у заходах, необхідних для забезпечення оборони України (одна гривня)"
    },
    "16": {
      "name": "Діти учасників АТО (100%)",
      "short": "Діти учасників АТО (100%)"
    },
    "17": {
      "name": "Діти членів сімей осіб, які брали( беруть) участь у заходах, необхідних для забезпечення оборони України (100%)",
      "short": "Діти членів сімей осіб, які брали( беруть) участь у заходах, необхідних для забезпечення оборони України (100%)"
    },
    "18": {
      "name": "Діти, які постраждали внаслідок воєнних дій і збройних конфліктів (100%)",
      "short": "Діти, які постраждали внаслідок воєнних дій і збройних конфліктів (100%)"
    },
    "19": {
      "name": "Діти членів сімей Захисників і Захисниць України, які перебувають в полоні або зникли безвісті (100%)",
      "short": "Діти членів сімей Захисників і Захисниць України, які перебувають в полоні або зникли безвісті (100%)"
    },
    "20": {
      "name": "Діти членів сімей киян-Захисників і киянок-Захисниць України, які перебувають у полоні або зникли безвісті (100%)",
      "short": "Діти членів сімей киян-Захисників і киянок-Захисниць України, які перебувають у полоні або зникли безвісті (100%)"
    },
    "21": {
      "name": "Діти, які постраждалі в наслідок Чорнобильської катастрофи (100%)",
      "short": "Діти, які постраждалі в наслідок Чорнобильської катастрофи (100%)"
    },
    "22": {
      "name": "Діти киян - Героїв Небесної Сотні (100%) (100%)",
      "short": "Діти киян - Героїв Небесної Сотні (100%) (100%)"
    },
    "23": {
      "name": "Діти киян - постраждалих учасників Революції Гідності (100%)",
      "short": "Діти киян - постраждалих учасників Революції Гідності (100%)"
    },
    "24": {
      "name": "Діти загиблих( померлих) ветеранів війни (100%)",
      "short": "Діти загиблих( померлих) ветеранів війни (100%)"
    }
};

export const schema = [
    {h: "#", f: "number"},
    {h: "Район", f: "district"},
    {h: "Номер ЗДО", f: "kgnumber", btitle: true}
];